const options = [
  {
    key: 'app',
    label: 'Dashboard',
    leftIcon: 'players',
  },
];

export default options;
